import * as THREE from 'three';

// Loads the arcade tools/build-arcade.mjs cut into screens and marquees -
// the room with everything off, the light every source adds (diff), the
// lossless id map and the per-screen homographies - once, at startup, for
// visualizers/arcade.js. Same shape and rule as alley-assets.js: the
// preload is a WIRING POINT every entry point must call.
const MANIFEST_URL = 'textures/arcade.json';

let _assets = null;
let _promise = null;

function loadTexture(url, configure) {
  return new Promise(function (resolve, reject) {
    new THREE.TextureLoader().load(url, function (t) { configure(t); t.needsUpdate = true; resolve(t); }, undefined, function () {
      reject(new Error(url + ' failed to load'));
    });
  });
}

function photo(t) {
  t.colorSpace = THREE.SRGBColorSpace;
  t.generateMipmaps = false;
  t.minFilter = THREE.LinearFilter;
  t.magFilter = THREE.LinearFilter;
  t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
}

export function preloadArcade() {
  if (_promise) return _promise;
  _promise = fetch(MANIFEST_URL)
    .then(function (r) {
      if (!r.ok) throw new Error('arcade.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (manifest) {
      return Promise.all([
        loadTexture('textures/' + manifest.off, photo),
        loadTexture('textures/' + manifest.diff, photo),
        loadTexture('textures/' + manifest.ids, function (t) {
          t.colorSpace = THREE.NoColorSpace;
          t.generateMipmaps = false;
          t.minFilter = THREE.NearestFilter;
          t.magFilter = THREE.NearestFilter;
          t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
        }),
        fetch('textures/' + manifest.data).then(function (r) {
          if (!r.ok) throw new Error(manifest.data + ' HTTP ' + r.status);
          return r.json();
        })
      ]).then(function (parts) {
        _assets = { manifest: manifest, off: parts[0], diff: parts[1], ids: parts[2], data: parts[3] };
        return _assets;
      });
    })
    .catch(function (err) {
      console.error('[party-mode] arcade assets unavailable, Arcade will stay dark', err);
      _assets = null;
      return null;
    });
  return _promise;
}

export function getArcade() {
  return _assets;
}

// Node tests only: hand in assets without a fetch.
export function _setArcadeForTests(a) { _assets = a; _promise = Promise.resolve(a); }
